import { ApplicationConfig, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { sanaTherapistAppRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDeAt from '@angular/common/locales/de-AT';
import { registerLocaleData } from '@angular/common';
import { primeNgDayNames, primeNgDayNamesShort, primeNgMonthNames, primeNgMonthNamesShort } from '@base/configs/primeng-translations.config';
import { TherapistAuthInterceptor } from './shared/interceptors/therapist-auth-interceptor.service';
import { TherapistAuthStateService } from '@therapist/shared/services/state/therapist-auth-state.service';
import { SanactivoPrimengPreset } from '@base/configs/primeng-preset.config';
import { MessageService } from 'primeng/api';

registerLocaleData(localeDeAt, 'de-AT');

export const sanaTherapistAppConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      sanaTherapistAppRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      })
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: SanactivoPrimengPreset,
        options: {
          darkModeSelector: '.sapp-dark'
        }
      },
      translation: {
        monthNames: primeNgMonthNames,
        monthNamesShort: primeNgMonthNamesShort,
        dayNames: primeNgDayNames,
        dayNamesShort: primeNgDayNamesShort,
        dayNamesMin: primeNgDayNamesShort
      }
    }),
    [{ provide: HTTP_INTERCEPTORS, useClass: TherapistAuthInterceptor, multi: true }],
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => inject(TherapistAuthStateService).initializeAppAndProfile()),
    { provide: LOCALE_ID, useValue: 'de-AT' },
    MessageService
  ]
};
